module.exports = __webpack_public_path__ + "static/media/veneto-3-13.d7dd7702.jpg";